"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppDBDocumentFilterEntity = void 0;
var AppDBDocumentFilterEntity;
(function (AppDBDocumentFilterEntity) {
    AppDBDocumentFilterEntity["UserId"] = "USER_ID";
    AppDBDocumentFilterEntity["GroupId"] = "GROUP_ID";
})(AppDBDocumentFilterEntity = exports.AppDBDocumentFilterEntity || (exports.AppDBDocumentFilterEntity = {}));
